export default "__VITE_ASSET__d8d1b3fb__"